import { Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 3,
        py: 3,
        mt: 4,
        borderTop: "1px solid rgba(0,0,0,0.1)",
        backgroundColor: "rgba(255,255,255,0.6)",
      }}
    >
      <Link component={RouterLink} to="/privacy" color="text.secondary" underline="hover" variant="body2">
        Privacy Policy
      </Link>
      <Link component={RouterLink} to="/terms" color="text.secondary" underline="hover" variant="body2">
        Terms of Service
      </Link>
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} Whitesides Family Blog
      </Typography>
    </Box>
  );
};

export default Footer;
